import { NavLink, useLocation } from "react-router-dom";

export default function Nav() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  const isHome = pathname === "/";

  const navClass = ({ isActive }) =>
    `nav-link text-sm font-serif-display italic text-white/75 hover:text-white ${
      isActive ? "active text-white" : ""
    }`;

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-40 transition-colors duration-500 ${
        isHome
          ? "bg-transparent"
          : "backdrop-blur-xl bg-[rgba(11,12,14,0.72)] border-b border-white/[0.04]"
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <div className="flex items-center gap-6 md:gap-10">
          <NavLink
            to="/"
            data-testid="nav-home-link"
            className={({ isActive }) =>
              `nav-link text-sm font-serif-display italic text-white/85 hover:text-white ${
                isActive ? "active text-white" : ""
              }`
            }
            end
          >
            Carol Lines
          </NavLink>
          <NavLink to="/about" data-testid="nav-about-link" className={navClass}>
            About
          </NavLink>
        </div>

        <nav className="flex items-center gap-8 md:gap-12">
          <NavLink to="/explore" data-testid="nav-explore-link" className={navClass}>
            Explore
          </NavLink>
          <NavLink to="/gallery" data-testid="nav-gallery-link" className={navClass}>
            Gallery
          </NavLink>
        </nav>
      </div>
    </header>
  );
}
